import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class VideoxService {
  constructor(private commonApiService: CommonApiService) {}

  onVideoxCreate(payload: any) {
    return this.commonApiService.post(APIURL.createVideox, payload);
  }

  fetchVideoXDetails(videoXId: any) {
    return this.commonApiService.get(APIURL.videoXDetails + videoXId);
  }

  onVideoXGenerate(payload: any) {
    return this.commonApiService.post(APIURL.videoXGenerate, payload);
  }

   videoXGeneratev2(payload: any) {
    return this.commonApiService.post(APIURL.videoXGeneratev2, payload);
  }

  onShotVideoApprove(payload: any) {
    return this.commonApiService.post(APIURL.shotVideoApprove, payload);
  }

  removeVideo(video_id) {
    return this.commonApiService.delete(APIURL.removeVideo + video_id);
  }
}
